import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { CaptionsViewMode } from "../../../Internals/ViewModeSelector/ViewModes";

import { Short } from "./Short";

const mapStateToProps = (state: FullFormState) => ({
    visible: state.viewModes.captions === CaptionsViewMode.Short,
});

export const ShortContainer = connect(mapStateToProps)(Short);
